var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.currentRow.id ? _vm.$t("编辑菜单") : _vm.$t("新增菜单"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "roleFrom",
    attrs: {
      model: _vm.roleFrom,
      rules: _vm.roleRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "icon",
      label: _vm.$t("Icon图标")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.roleFrom.icon,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "icon", $$v);
      },
      expression: "roleFrom.icon"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("菜单名称")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.roleFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "name", $$v);
      },
      expression: "roleFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "link",
      label: _vm.$t("菜单地址")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.roleFrom.link,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "link", $$v);
      },
      expression: "roleFrom.link"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "mark",
      label: _vm.$t("菜单标识")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.roleFrom.mark,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "mark", $$v);
      },
      expression: "roleFrom.mark"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("排序")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      id: "inputNumber",
      min: 0
    },
    model: {
      value: _vm.roleFrom.sort,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "sort", $$v);
      },
      expression: "roleFrom.sort"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "isShow",
      label: _vm.$t("状态")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.roleFrom.isShow,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "isShow", $$v);
      },
      expression: "roleFrom.isShow"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("可见")) + " ")]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("隐藏")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "isOpen",
      label: _vm.$t("客户是否可见")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.roleFrom.isOpen,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "isOpen", $$v);
      },
      expression: "roleFrom.isOpen"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("是")) + " ")]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("否")) + " ")])], 1), _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("备注：默认不修改（客户系统是否可以看见）")))])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注")
    }
  }, [_c("a-input", {
    attrs: {
      type: "textarea"
    },
    model: {
      value: _vm.roleFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "remark", $$v);
      },
      expression: "roleFrom.remark"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };